/**
 *
 * Asynchronously loads the component for Agents
 *
 */

import { lazyLoad } from 'utils/loadable';

export const Agents = lazyLoad(() => import('./index'));
